import React, { type ReactNode } from 'react'

import getIntl from 'Helpers/intl'
import { isNullOrEmpty } from 'Helpers/strings'

import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow,
} from 'mailup-web-components'

import AddRecipientExisting from 'Pages/RecipientsList/components/notifications/AddRecipientExisting'

import type {
  ChannelSubscriptionStatus,
  SearchResult,
} from 'Pages/RecipientsList/model'

export const notifyFindReplaceSuccess = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.FindReplaceNotifySuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyEmptyFieldSuccess = (field: string): void => {
  toastShow(
    <>
      {getIntl().formatMessage(
        {
          id: 'Load.RecipientsList.EmptyFieldNotifySuccess',
        },
        {
          FIELD: field,
          strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
        },
      )}
    </>,
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifySubscriptionStatusUpdateSuccess = (
  status: NonNullable<ChannelSubscriptionStatus>,
  contact: SearchResult['Email'],
): void => {
  toastShow(
    getIntl().formatMessage(
      {
        id:
          status === 'SUBSCRIBED'
            ? 'Load.RecipientsList.RecipientSetSubscribedSuccess'
            : status === 'PENDING'
              ? 'Load.RecipientsList.RecipientSetPendingSuccess'
              : 'Load.RecipientsList.RecipientSetUnsubscribedSuccess',
      },
      {
        CONTACT: !isNullOrEmpty(contact) ? contact : undefined,
      },
    ),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifySetPendingSendConfirmationSuccess = (
  sendConfirmation: boolean,
  contact: SearchResult['Email'],
): void => {
  toastShow(
    getIntl().formatMessage(
      {
        id: sendConfirmation
          ? 'Load.RecipientsList.RecipientSetPendingSentConfirmationSuccess'
          : 'Load.RecipientsList.RecipientSetPendingSuccess',
      },
      {
        CONTACT: !isNullOrEmpty(contact) ? contact : undefined,
      },
    ),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifySendConfirmationSuccess = (
  contact: SearchResult['Email'],
): void => {
  toastShow(
    getIntl().formatMessage(
      {
        id: 'Load.RecipientsList.SendConfirmationSuccess',
      },
      {
        CONTACT: contact,
      },
    ),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifySubscribeMultilistSuccess = (
  contactEmail: SearchResult['Email'],
  contactSMS: SearchResult['Mobile'],
): void => {
  toastShow(
    getIntl().formatMessage(
      {
        id: 'Load.RecipientsList.SubscribeMultilistSuccess',
      },
      {
        CONTACT: !isNullOrEmpty(contactEmail) ? contactEmail : contactSMS,
      },
    ),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyAddRecipientSuccess = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.AddRecipientSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyAddRecipientExisting = (idRecipient: number): void => {
  toastShow(
    <AddRecipientExisting idRecipient={idRecipient} />,
    TOAST_VARIANT_ERROR,
  )
}

export const notifyAddRecipientMultiple = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.AddRecipientMultiple',
    }),
    TOAST_VARIANT_ERROR,
  )
}

export const notifyDelStatsContactSendSuccess = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.ModalDelStatsContactSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyEditContactsSuccess = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.EditContactsSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyEditContactsError = (
  reason:
    | 'REMOVING'
    | 'MAIL_EXISTING'
    | 'MOBILE_EXISTING'
    | 'MAIL_MOBILE_EXISTING',
  { email, sms }: { email: string; sms: string },
): void => {
  toastShow(
    getIntl().formatMessage(
      {
        id:
          reason === 'REMOVING'
            ? 'Load.RecipientsList.EditContactsErrorRemoving'
            : reason === 'MAIL_EXISTING'
              ? 'Load.RecipientsList.EditContactsErrorMailExisting'
              : reason === 'MOBILE_EXISTING'
                ? 'Load.RecipientsList.EditContactsErrorMobileExisting'
                : 'Load.RecipientsList.EditContactsErrorMailMobileExisting',
      },
      {
        email,
        sms,
      },
    ),
    TOAST_VARIANT_ERROR,
  )
}

export const notifyTrackingUpdateSuccess = (tracking: boolean): void => {
  toastShow(
    getIntl().formatMessage({
      id: tracking
        ? 'Load.ActiveRecipientSummary.EnableTrackingSucces'
        : 'Load.ActiveRecipientSummary.StopTrackingSucces',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyCreateSegmentSuccess = (name: string | null): void => {
  toastShow(
    getIntl().formatMessage(
      {
        id: 'Load.RecipientsList.SegmentCreateSuccess',
      },
      { NAME: name },
    ),
    TOAST_VARIANT_SUCCESS,
  )
}
